import React, { Component } from "react";
import BonusPage from "../components/bonusPage";
import { BonusCardModel } from "../components/bonusPage/bonusCard/model";
import { inject, observer } from "mobx-react";
import Head from "next/head";
import styles from "./profile/bonus/bonus.module.scss";
import BonusCard from "../components/bonusPage/bonusCard/bonusCard";
import Carousel from "react-multi-carousel";
import BonusStore from "../stores/BonusStore";
import SelectedCityStore from "../stores/SelectedCityStore";
import ResourceStore from "../stores/ResourseStore";
import { City } from "../entities";
import { cityFrom } from "lvovich";
import Spinner from "../components/spinner";
import ErrorPage from "../components/errorBoundary/errorPage";
import TokenStore from "../stores/TokenStore";
import BonusStub from "../components/bonusStub/bonusStub";

@inject("bonusStore")
@inject("citiesStore")
@inject("selectedCityStore")
@inject("tokenStore")
@observer
export default class Bonus extends Component<any, any> {
  props: {
    bonusStore?: BonusStore;
    citiesStore?: ResourceStore;
    selectedCityStore?: SelectedCityStore;
    tokenStore?: TokenStore
  };
  state: {
    bonuses: [];
    byCity: any;
    userCity: City;
    loading: boolean;
    error: boolean;
    errorText: string;
    isShow: boolean
  };
  responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 769 },
      items: 0,
    },
    mobile: {
      breakpoint: { max: 768, min: 601 },
      items: 2,
      slidesToSlide: 1,
    },
    extraMobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 84,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      bonuses: [],
      byCity: [],
      userCity: null,
      error: false,
      errorText: "",
    };
  }

  componentDidMount() {
    this.props.bonusStore
      .loadBonusesByUrl(
        `/api/bonuses/${this.props.selectedCityStore.cityID ? `?city_id=${this.props.selectedCityStore.cityID}` : ""}`
      )
      .then((r) => {
        const byCity = [];
        const bonuses = [];
        r.results.forEach((res) => {
          const bonusModel = new BonusCardModel(res);
          if(res.cities.length > 0) {
            byCity.push(bonusModel);
          }

          if(res.cities.length == 0) {
            bonuses.push(bonusModel);
          }

        })

        this.setState({
          byCity: byCity,
          bonuses: bonuses,
          loading: false,
        });
      })
      .catch(async (res) => {
        if (res.response?.status === 403) {
          const data = await res.response.data.detail;
          this.setState({
            errorText: data,
            loading: false,
          });
        } else {
          this.setState({
            error: true,
          });
        }
      });
    this.props.citiesStore
      .loadOne(this.props.selectedCityStore.cityID)
      .then((r) => {
        this.setState({
          userCity: r,
          loading: false,
        });
      })
      .catch(() => {});
    if(this.props.tokenStore.get()) {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 180);
      const formattedDate = currentDate.toISOString().split('T')[0];
      this.props.bonusStore
      .getLastAcceptedDonation(formattedDate)
      .then((r) => {
        this.setState({
          isShow: !!r.data.count
        });
      })
      .catch(() => {});
    } else {
      this.setState({
        isShow: false
      });
    }
  }

  render() {
    const { props, state, responsive } = this;
    const { byCity, bonuses, userCity, loading, error, isShow } = state;
    // console.log(isShow)
    if (error) {
      return <ErrorPage />;
    }

    if (!loading) {
      return (
        <>
          <Head>
            <title>Бонусы донорам | DonorSearch.org</title>
          </Head>
          {/* Если пользователь авторизован и у него не было донаций более 180ти дней */}
          {byCity?.length > 0 && (
            <>
              <BonusPage
                bonuses={byCity}
                mobile={false}
                bonusMetrics={"to_bonus_from_profile"}
                titleAdditionalClass={true}
                noMarginTop
                paddingContainer={"24px 32px 32px"}
                title={`Бонусы донорам ${
                  userCity?.title ? cityFrom(userCity?.title) : ""
                }`}
                isShow={isShow}
                isHidden={true}
              />
              <div className={styles.CarouselContainer + " container"}>
                <div className={styles.CoruselContent}>
                  {
                    !isShow && <BonusStub />
                  }
                  <Carousel
                    partialVisible={byCity?.length > 1}
                    arrows={false}
                    swipeable={true}
                    draggable={true}
                    showDots={false}
                    ssr={true}
                    className={styles.Carousel}
                    responsive={responsive}
                    itemClass={styles.CarouselItem}
                  >
                    {byCity?.map((bonus) => {
                      return (
                        <BonusCard
                          info={bonus}
                          showDesktopOnMobile={true}
                          key={bonus.id}
                          metricsOnClick={"to_bonus_from_profile"}
                        />
                      );
                    })}
                  </Carousel>
                </div>
              </div>
            </>
          )}
          <BonusPage
            bonuses={bonuses}
            title={"Бонусы донорам"}
            noMarginTop
            paddingContainer={"24px 32px 32px"}
            bonusMetrics={"to_bonus_from_bonuses"}
            isShow={isShow}
          />
        </>
      );
    } else
      return (
        <div className={styles.LoadingBlock}>
          <Spinner background={true} toggled={true} />
        </div>
      );
  }
}
